import { createFileRoute, useRouter } from "@tanstack/react-router"
import { useServerFn } from "@tanstack/react-start"

import config from "@/config"

import { CustomerDetailView } from "../components/customer-detail/customer-detail"
import { PageError, PageLoading } from "../components/page-state/page-state"
import {
  createCustomerAction,
  deleteCustomerAction,
  loadCustomer,
  loadInvoiceList,
  updateCustomerAction,
} from "../rpc"

export const Route = createFileRoute("/_app-shell/customers/$id")({
  loader: async ({ params }) => {
    const [customer, invoices] = await Promise.all([
      loadCustomer({ data: { id: params.id } }),
      loadInvoiceList({ data: { customerId: params.id } }),
    ])
    return { customer, invoices }
  },
  head: () => ({
    meta: [
      { title: `Customer - ${config.core.projectName}` },
      { name: "robots", content: "noindex" },
    ],
  }),
  pendingComponent: () => <PageLoading title="Customer" label="Loading the customer" />,
  errorComponent: ({ error }) => {
    const router = useRouter()
    return (
      <PageError
        title="Customer"
        message={error.message || "The customer could not be loaded."}
        onRetry={() => router.invalidate()}
      />
    )
  },
  component: CustomerDetailRoute,
})

function CustomerDetailRoute() {
  const { customer, invoices } = Route.useLoaderData()
  const router = useRouter()
  const create = useServerFn(createCustomerAction)
  const update = useServerFn(updateCustomerAction)
  const remove = useServerFn(deleteCustomerAction)

  return (
    <CustomerDetailView
      customer={customer}
      invoices={invoices}
      onSubmitCustomer={(id, request) =>
        id === null ? create({ data: request }) : update({ data: { id, request } })
      }
      onDelete={(id) => remove({ data: { id } })}
      onChanged={() => void router.invalidate()}
      onDeleted={() => router.navigate({ to: "/customers" })}
    />
  )
}
